import { FaClock, FaBriefcase, FaUsers, FaWheelchair } from 'react-icons/fa';

export const FreelanceTrainerBenefits = () => {
  const reasons = [
    {
      icon: <FaClock className="text-amber-500 w-6 h-6" aria-hidden="true" />,
      title: "Convenience",
      description:
        "Most of us would agree that they wouldn’t like long commuting hours to a gym especially in a busy city like Singapore. So, the nearer the better.",
    },
    {
      icon: <FaBriefcase className="text-amber-500 w-6 h-6" aria-hidden="true" />,
      title: "Busy work life",
      description:
        "If you have a busy work life you will understand the importance of having freelance trainer coaching at home.",
    },
    {
      icon: <FaUsers className="text-amber-500 w-6 h-6" aria-hidden="true" />,
      title: "Family Time",
      description:
        "Many of us need to take care of our kids or elderly and cannot afford to be away from home for long hours. In this case a home or condo gym workout perfectly makes sense.",
    },
    {
      icon: <FaWheelchair className="text-amber-500 w-6 h-6" aria-hidden="true" />,
      title: "Physical constraints",
      description:
        "People with mobility issues would prefer a freelance personal trainer at home to help them with functional training which is focused on compound movements to help strengthen muscles and joints.",
    },
  ];

  return (
    <section className='bg-slate-900 py-10'>
        <div
            aria-labelledby="freelance-trainer-benefits-title"
            className="max-w-5xl mx-auto px-6 rounded-3xl shadow-lg"
        >
                
            <h2 className="text-2xl md:text-3xl text-white text-center font-extrabold">Why Choose a Freelance Personal Trainer</h2>
            <div className='py-5 space-y-5 text-white/60 leading-relaxed'>
                <p>
                    Freelance personal trainers in Singapore offer unmatched flexibility. They aren&apos;t tied to any gym, so they can train you wherever it&apos;s most convenient — your home, condo gym, or even a nearby park or community facility.
                </p>
                <p>
                    Many bring along essential equipment like dumbbells, resistance bands, and workout mats. Since they avoid overhead gym fees, freelance trainers often provide more competitive rates for one-on-one sessions.
                </p>

                <p>
                    A significant number of people look for freelance personal trainers who can train them at their home or condo gym, or they look for nearby gyms with personal training. There could be several reasons for this growing preference.
                </p>

                <p>
                    Here are a few reasons that we often come across.
                </p>
            </div>

            <div className="grid gap-8 sm:grid-cols-2 relative">
                {reasons.map(({ icon, title, description }, idx) => (
                <article
                    key={idx}
                    className="space-x-4 p-6 rounded-xl shadow hover:shadow-md transition-shadow duration-300 relative overflow-hidden"
                    itemProp="mainEntity"
                    itemScope
                    itemType="https://schema.org/Question"
                >
                    {/* Mesh gradient blobs */}
                    <div className="absolute top-0 right-0 w-72 h-72 bg-blue-500/30 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3" />
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-violet-500/20 rounded-full blur-3xl -translate-x-1/4 translate-y-1/4" />
                    <div className="absolute top-1/2 right-1/4 w-40 h-40 bg-cyan-400/15 rounded-full blur-2xl" />
                    <div className="flex items-center mb-4 gap-2">
                        <div className="shrink-0 mt-1">{icon}</div>
                        <div itemProp="name" className="text-xl font-semibold text-amber-500">
                        {title}
                        </div>
                    </div>
                    <div
                    itemProp="acceptedAnswer"
                    itemScope
                    itemType="https://schema.org/Answer"
                    className="text-base leading-relaxed"
                    >
                        <p itemProp="text" className='text-white/80'>{description}</p>
                    </div>
                </article>
                ))}
            </div>
        </div>
    </section>
  );
};
